export interface CompletionReceipt { version: 1; boardId: string; score: number; words: number; when: number; limited: boolean }
export interface ProgressTotals { version: 1; points: number; boards: number; words: number; best: number; limited: boolean }
export const emptyProgress = (): ProgressTotals => ({ version: 1, points: 0, boards: 0, words: 0, best: 0, limited: false });
const natural = (value: unknown): value is number => Number.isSafeInteger(value) && Number(value) >= 0;
export function validProgress(value: unknown): value is ProgressTotals {
  if (!value || typeof value !== 'object') return false;
  const totals = value as ProgressTotals;
  return totals.version === 1 && [totals.points, totals.boards, totals.words, totals.best].every(natural) && typeof totals.limited === 'boolean'
    && totals.best <= totals.points && (totals.boards > 0 || totals.points === 0 && totals.words === 0 && totals.best === 0);
}
export function validReceipt(value: unknown): value is CompletionReceipt {
  if (!value || typeof value !== 'object') return false;
  const receipt = value as CompletionReceipt;
  return receipt.version === 1 && typeof receipt.boardId === 'string' && receipt.boardId.length > 0 && receipt.boardId.length <= 128
    && [receipt.score, receipt.words, receipt.when].every(natural) && typeof receipt.limited === 'boolean';
}
export function addCompletion(totals: ProgressTotals, receipt: CompletionReceipt): ProgressTotals {
  const next: ProgressTotals = { version: 1, points: totals.points + receipt.score, boards: totals.boards + 1,
    words: totals.words + receipt.words, best: Math.max(totals.best, receipt.score), limited: totals.limited || receipt.limited };
  if (!validProgress(next)) throw new Error('Invalid progress totals');
  return next;
}
